/*
 * 1-Minute Maths
 * Copyright © 2021 - 2022 White Rose Maths
 * HomeScreen.web.tsx - Home screen for the app (web version).
 */

import * as categoryDefinitions from '../../categories';
import { RootStackProps } from '../../navigation/types';
import './HomeScreen.web.css';

const HomeScreen = ({ navigation }: RootStackProps<'Home'>) => {
  return (
    
    <div id="wrapper">

      <div id="header">
        <div className="settings" />
        <div className="logo">
          <img src={require('../../assets/images/HomePageLogo_72dpi.png')} alt="Logo" className="logoImage" />
        </div>
        <div className="brand">
          <img src={require('../../assets/images/HomePageWRMLogo_72dpi.png')} alt="Brand" className="brandImage" />
        </div>
      </div>

      <div id="content">
        {categoryDefinitions.topic_categories.map((category, index) => {
          return (
            <div className="ButtonView" key={index}>
              <button
                disabled={category.disabled}
                className="home_page_button"
                onClick={() => navigation.navigate('Category', category)}
                onMouseEnter={() => {
                  const image = document.getElementById(`${category.name}image`);
                  if (image !== null) {
                    image.style.transition = 'all 3s ease-in-out';
                    image.style.transform = 'rotate(720deg)';
                  }

                  const imageContainer = document.getElementById(`buttonImageContainer${category.name}`);
                  const textContainer = document.getElementById(`buttonTextContainer${category.name}`);
                  imageContainer?.classList.add('blue_border');
                  textContainer?.classList.add('blue_border');
                  textContainer?.classList.add('wider_letters');
                }}
                onMouseLeave={() => {
                  const image = document.getElementById(`${category.name}image`);
                  if (image !== null) {
                    image.style.transition = 'all 0s';
                    image.style.transform = 'rotate(0deg)';
                  }

                  const imageContainer = document.getElementById(`buttonImageContainer${category.name}`);
                  const textContainer = document.getElementById(`buttonTextContainer${category.name}`);                
                  imageContainer?.classList.remove('blue_border');
                  textContainer?.classList.remove('blue_border');
                  textContainer?.classList.remove('wider_letters');
                }}
              >

                <div
                  className="home_page_button_image_container"
                  style={{ backgroundColor: category.color }}
                  id={`buttonImageContainer${category.name}`}
                >
                  <img
                    src={category.icon}
                    className="home_page_button_image_icon"
                    id={`${category.name}image`}
                  />
                </div>

                <div
                  className="home_page_button_text_container"
                  style={{ backgroundColor: category.buttonColor }}
                  id={`buttonTextContainer${category.name}`}
                >
                  <p className="home_page_button_text">
                    {' '}
                    {category.name}
                    {' '}
                  </p>
                </div>
              </button>
            </div>
          );
        })}
      </div>

      <footer><p className="footerText">© White Rose Education Limited</p></footer>
    </div>
  );
};

export default HomeScreen;
